import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the InformationBetShopView.
 * @extends JetView
 */
export default class InformationBetShopView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the current screen size
        const main_info = {
            // Main information layout
            margin: 10,
            rows: [
                {
                    view: 'text', // Text input for total sports stakes
                    name: 'TotalSportStakes',
                    label: _('Total Apuestas Deportivas'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Total Apuestas Deportivas'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for total unsettled bets
                    name: 'TotalUnsettledBets',
                    label: _('Apuestas Totales Liquidadas'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Apuestas Totales Liquidadas'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for total sports winnings
                    name: 'TotalSportWinnings',
                    label: _('Total Ganancias Deportivas'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Total Ganancias Deportivas'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for sports profitness
                    name: 'SportProfitness',
                    label: _('Deporte Profitness'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Deporte Profitness'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for total casino stakes
                    name: 'TotalCasinoStakes',
                    label: _('Total Apuestas Casino'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Total Apuestas Casino'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for total casino winnings
                    name: 'TotalCasinoWinnings',
                    label: _('Ganancias Totales Casino'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Ganancias Totales Casino'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for casino profitness
                    name: 'CasinoProfitness',
                    label: _('Casino Profitness'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Casino Profitness'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for total deposits
                    name: 'TotalDeposit',
                    label: _('Total Depósitos'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Total Depósitos'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
                {
                    view: 'text', // Text input for total withdrawals
                    name: 'TotalWithdrawal',
                    label: _('Total Retiros'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Total Retiros'), // Localized placeholder
                    disabled: true, // Input is disabled
                },
            ],
        };
        const left_main = {
            // Left main section layout
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };
        const more_info = {
            // More information section layout
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [],
        };
        const upper_section = {
            // Upper section layout for larger screens
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 20 }, more_info, { gravity: 2, minWidth: 20 }],
        };
        const upper_section_narrow = {
            // Upper section layout for smaller screens
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info, more_info],
                },
                { gravity: 1, minWidth: 20 },
            ],
        };
        return {
            // Return the final configuration
            view: 'form',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(
            this.app,
            'customer:updatedataFinance',
            (
                person, // Event listener for finance data update
            ) => form.setValues(person),
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for person selection
        this.getLocalizedComboOptions(); // Fetch localized combo options
    }

    /**
     * Retrieves and sets localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions options
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parse positions into combo

        let t_options = webix.copy(getTags()); // Get tags options
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parse tags into combo

        let c_options = webix.copy(getCities()); // Get cities options
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parse cities into combo
    }
}

// FILE DOCUMENTED
